import type { SiteConfig, NavLink } from '../../../siteContentTypes.ts';
import { TextField, ToggleField, ListEditor } from './fields.tsx';

export function HeaderSection({ config, update }: { config: SiteConfig; update: (patch: Partial<SiteConfig>) => void }) {
  const h = config.header;
  const set = (patch: Partial<SiteConfig['header']>) => update({ header: { ...h, ...patch } });

  return (
    <div>
      <h2 style={{ fontSize: 18, fontWeight: 800, marginBottom: 20 }}>Navigation</h2>
      <ToggleField label="Header sticky au scroll" value={h.sticky} onChange={(v) => set({ sticky: v })} />
      <ToggleField label="Header transparent (avant scroll)" value={h.transparent} onChange={(v) => set({ transparent: v })} />
      <TextField label="Texte bouton secondaire" value={h.ctaSecondaryText} onChange={(v) => set({ ctaSecondaryText: v })} />
      <TextField label="Lien bouton secondaire" value={h.ctaSecondaryUrl} onChange={(v) => set({ ctaSecondaryUrl: v })} />
      <TextField label="Texte bouton principal" value={h.ctaPrimaryText} onChange={(v) => set({ ctaPrimaryText: v })} />
      <TextField label="Lien bouton principal" value={h.ctaPrimaryUrl} onChange={(v) => set({ ctaPrimaryUrl: v })} />

      <h3 style={{ fontSize: 14, fontWeight: 800, margin: '24px 0 10px' }}>Liens du menu</h3>
      <ListEditor<NavLink>
        items={h.links}
        onChange={(links) => set({ links })}
        itemLabel="un lien"
        newItem={() => ({ label: 'Nouveau lien', url: '#', order: h.links.length, visible: true })}
        renderItem={(link, patch) => (
          <>
            <TextField label="Libellé" value={link.label} onChange={(v) => patch({ label: v })} />
            <TextField label="URL" value={link.url} onChange={(v) => patch({ url: v })} />
            <ToggleField label="Visible" value={link.visible} onChange={(v) => patch({ visible: v })} />
          </>
        )}
      />
    </div>
  );
}
